'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _utils = require('../../utils');

var _common = require('../common');

var _DownloadLienStatementButton = require('./DownloadLienStatementButton');

var _DownloadLienStatementButton2 = _interopRequireDefault(_DownloadLienStatementButton);

var _DownloadLienStatementDropdown = require('./DownloadLienStatementDropdown');

var _DownloadLienStatementDropdown2 = _interopRequireDefault(_DownloadLienStatementDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var CaseSearchResultsHeader = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultsHeader, _Component);

  function CaseSearchResultsHeader() {
    _classCallCheck(this, CaseSearchResultsHeader);

    return _possibleConstructorReturn(this, (CaseSearchResultsHeader.__proto__ || Object.getPrototypeOf(CaseSearchResultsHeader)).apply(this, arguments));
  }

  _createClass(CaseSearchResultsHeader, [{
    key: 'renderLienStatementButton',
    value: function renderLienStatementButton() {
      var _props = this.props,
          headerObject = _props.headerObject,
          headerType = _props.headerType,
          lawfirm = _props.lawfirm;


      if (!this.shouldShowLienStatementButton) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'download-lien-statement' },
        headerType === 'lawfirm' ? _react2.default.createElement(_DownloadLienStatementDropdown2.default, { lawfirm: lawfirm }) : _react2.default.createElement(_DownloadLienStatementButton2.default, { contact: headerObject, contactType: headerType, lawfirm: lawfirm })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var headerObject = this.props.headerObject;


      return _react2.default.createElement(
        'div',
        { className: 'header' },
        this.renderLienStatementButton(),
        _react2.default.createElement(
          'h1',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: this.contactPageURL },
            getNameOrDefault(headerObject),
            ' '
          ),
          _react2.default.createElement(
            'div',
            { className: 'contact-info' },
            headerObject.phone_number && _react2.default.createElement(
              'span',
              { className: 'item' },
              _react2.default.createElement(_common.Icon, { type: 'phone' }),
              ' ',
              headerObject.phone_number
            ),
            headerObject.fax_number && _react2.default.createElement(
              'span',
              { className: 'item' },
              _react2.default.createElement(_common.Icon, { type: 'fax' }),
              ' ',
              headerObject.fax_number
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'contactPageURL',
    get: function get() {
      var _props2 = this.props,
          headerObject = _props2.headerObject,
          headerType = _props2.headerType,
          linkFields = {
        attorney: 'people',
        contacts: 'people',
        facility: 'organizations',
        facility_contact: 'people',
        lawfirm: 'lawfirms',
        provider: 'people'
      },
          linkField = linkFields[headerType];


      return '/contacts/' + linkField + '/' + headerObject.id + '/';
    }
  }, {
    key: 'shouldShowLienStatementButton',
    get: function get() {
      var _props3 = this.props,
          FunderStore = _props3.FunderStore,
          headerType = _props3.headerType,
          lawfirm = _props3.lawfirm,
          funderHasLawFirmTemplate = headerType === 'lawfirm' && FunderStore.templateLawFirm,
          funderHasAttorneyTemplate = headerType === 'attorney' && FunderStore.templateAttorney;


      return !!lawfirm && (funderHasLawFirmTemplate || funderHasAttorneyTemplate);
    }
  }]);

  return CaseSearchResultsHeader;
}(_react.Component), _class2.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  headerObject: _propTypes2.default.object.isRequired,
  headerType: _propTypes2.default.string,
  lawfirm: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = CaseSearchResultsHeader;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case-search-results/CaseSearchResultsHeader.js');
  reactHotLoader.register(CaseSearchResultsHeader, 'CaseSearchResultsHeader', '/app/src/components/page-case-search-results/CaseSearchResultsHeader.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultsHeader.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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